import Vue from "vue";
import Vuex from "vuex";
// import VuexPersist from "vuex-persist";
import VuexPersistence from "vuex-persist";
import VuexSharedMutations from "vuex-shared-mutations";
import Cookies from "js-cookie";

import user from "@/store/_user";

Vue.use(Vuex);

const storageKey = process.env.VUE_APP_COOKIE;

const cookieStorage = new VuexPersistence({
  key: storageKey,
  storage: window.localStorage,
  reducer: state => ({
    user: {
      account: state.user.account,
      bankList: state.user.bankList,
      language: state.user.language,
      royaltyLevel: state.user.royaltyLevel,
      promoList: state.user.promoList,
      gameSelected: state.user.gameSelected
    }
  })
});

// const cookieStorage = new VuexPersistence({
//   key: storageKey,
//   restoreState: (key) => Cookies.getJSON(key),
//   saveState: (key, state) =>
//   Cookies.set(key, state, {
//     expires: new Date(new Date().getTime() + 12 * 60 * 60 * 1000)
//   }),
//   reducer: state => ({
//     user: {
//       account: state.user.account,
//       transaction: state.user.transaction,
//       language: state.user.language,
//       royaltyLevel: state.user.royaltyLevel
//     }
//   })
// });

const store = new Vuex.Store({
  modules: {
    user
  },
  getters: {
    language: state => {
      return state.user.language;
    },
    transferDetails: state => {
      return state.user.transferDetails;
    },
    betHistory: state => {
      return state.user.betHistory;
    },
    slotResult: state => {
      return state.user.slotResult;
    },
    promoList: state => {
      return state.user.promoList;
    },
    rebateResult: state => {
      return state.user.rebateResult;
    }, 
    sbResult: state => {
      return state.user.sbResult;
    },
    livecasinoResult: state => {
      return state.user.livecasinoResult;
    },
    downlineList : state => {
      return state.user.downlineList;
    },
    claimedTicketsList : state => {
      return state.user.claimedTicketsList;
    },
    refreshKey: state => {
      return state.user.refreshKey;
    },
    accountID: state => {
      if(Object.keys(state.user.account).length > 0){
        if(state.user.account.auth_token.length > 0){
          return state.user.account.auth_token[0].account_id;
        }
      } 
    },
    username: state => {
      if(Object.keys(state.user.account).length > 0){
        if(state.user.account.auth_token.length > 0){
          return state.user.account.auth_token[0].nickname;
        }
      }
    },
    sessionToken: state => {
      if(Object.keys(state.user.account).length > 0){
        if(state.user.account.auth_token.length > 0){
          return state.user.account.auth_token[0].session_token;
        }
      }     
    },
    currency: state => {
      if(Object.keys(state.user.account).length > 0){
        if(state.user.account.balance.length > 0){
          return state.user.account.balance[0].currency_code;
        }
      }
    },
    balance: state => {
      return state.user.balance;
    },
    gameToken: state => {
      return state.user.gameToken;
    },
    lastLoginTime: state => {
      if(Object.keys(state.user.account).length > 0){
        if(state.user.account.auth_token.length > 0){
          return state.user.account.auth_token[0].last_login_time;
        }
      }
    },
    bankList: state => {
      return state.user.bankList;
    },
    isLoggedIn: state => {
      if(Object.keys(state.user.account).length > 0){
        if (state.user.account.auth_token[0].session_token) {
          return true;
        } else {
          return false;
        }
      }

      // if(state.user.account.length > 0){
      //   if (state.user.account.auth_token[0].session_token) {
      //     return true;
      //   } else {
      //     return false;
      //   }
      // }else{
      //   return false
      // }
      
    },
    slotSelected: state => {
      return state.user.slotSelected;
    },
    promoSelected: state => {
      return state.user.promoSelected;
    },
    gameSelected: state => {
      return state.user.gameSelected;
    },
    promoDetail: state => {
      return state.user.promoDetail;
    },
    settlementDate: state => {
      return state.user.settlementDate;
    },
  },
  plugins: [
    cookieStorage.plugin,
    VuexSharedMutations({
      predicate: [
        "user/uTransferDetails",
        "user/uBetHistory",
        "user/uLivecasinoResult",
        "user/uSlotResult",
        "user/uPromo",
        "user/uRebateResult",
        "user/uSbResult",
        "user/uClaimedTicketsList",
        "user/update",
        "user/delete",
        "user/updateBalance",
        "user/updateRefreshKey",
        "user/updateLanguage"
      ]
    })
  ]
});

export default store;
